import { Callout } from "@octopusdeploy/design-system-components";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import InternalLink from "~/components/Navigation/InternalLink";
import useLocalStorage from "~/hooks/useLocalStorage";
interface EphemeralEnvironmentCreationFailedCalloutProps {
    projectId: string;
    lastFailureEvent?: string;
    failureSearchStartDate: string;
    canViewAuditEvents: boolean;
}
export default function EphemeralEnvironmentCreationFailedCallout({ projectId, failureSearchStartDate, lastFailureEvent, canViewAuditEvents }: EphemeralEnvironmentCreationFailedCalloutProps) {
    const [calloutDismissed, setCalloutDismissed] = useLocalStorage(`Octopus.Callout.EphemeralEnvironmentCreationFailedCallout.DismissedEventDate.${projectId}`, "");
    if (!lastFailureEvent) {
        return null;
    }
    // If user dismissed the callout and no new events have occurred since, don't show it
    if (calloutDismissed && new Date(lastFailureEvent).getTime() === new Date(calloutDismissed).getTime()) {
        return null;
    }
    return (<Callout title="Ephemeral Environment Creation Failed" type={"danger"} canClose={true} onClose={() => setCalloutDismissed(lastFailureEvent)}>
            <p>
                {canViewAuditEvents ? (<>
                        There were issues creating some ephemeral environments. Please check the
                        <InternalLink to={links.auditPage.generateUrl({ projects: [projectId], eventCategories: ["EphemeralEnvironmentCreationFailed"], from: new Date(failureSearchStartDate).toISOString() })}> audit page</InternalLink> for more
                        details.
                    </>) : (<>There were issues creating some ephemeral environments. Ask an Octopus administrator to check the audit log or grant you access.</>)}
            </p>
        </Callout>);
}
